function formatTimeInHMS(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [hrs.toString().padStart(2, '0'), mins.toString().padStart(2, '0'), secs.toString().padStart(2, '0')].join(
    ':',
  );
}

function formatToISTTime(isoString) {
  const date = new Date(isoString);
  return date
    .toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    })
    .toLowerCase(); // to make "AM"/"PM" lowercase
}

function formatTimeInHMSString(totalSeconds) {
  if (!totalSeconds || totalSeconds === 0) {
    return '-';
  }

  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const hrPart = hrs > 0 ? `${hrs} hr` : '';
  const minPart = mins > 0 ? `${mins} min` : '';
  const secPart = secs > 0 ? `${secs} sec` : '';

  const result = `${hrPart} ${minPart} ${secPart}`.trim();
  return result;
}

export { formatTimeInHMS, formatToISTTime, formatTimeInHMSString };
